import { useMutation } from '@apollo/client';

import { ControlVisitModalProps } from './control-visit-modal.models';
import { ControlVisitModal as ControlVisitModalView } from './control-visit-modal';
import { UPDATE_NOTIFICATION } from '../../../../../../../graphql/notifications/mutations/update-notification';
import { useActionsInProgress } from '../../../../../../../graphql';
import { promiseErrorCallbacks } from '../../../../../../../utils/promise/set-promise-error-callbacks';
import { useCancellablePromise } from '../../../../../../../hooks';

export const ControlVisitModal = ({
  notificationId, updateNotifications: updateNotificationsInCache, onClose, ...props
}: ControlVisitModalProps): JSX.Element => {
  const [updateNotification] = useMutation(UPDATE_NOTIFICATION);
  const { addActionInProgress, removeActionInProgress } = useActionsInProgress();
  const {
    makeCancellablePromise,
    CancelledPromiseOnUnmountError,
  } = useCancellablePromise();

  const handleModalClose = async () => {
    try {
      addActionInProgress();

      await makeCancellablePromise(
        updateNotification({
          variables: {
            notificationId,
          },
        }),
      );

      updateNotificationsInCache(notificationId);
    } catch (error) {
      if (error instanceof CancelledPromiseOnUnmountError) {
        return;
      }

      if (promiseErrorCallbacks.anyError) {
        promiseErrorCallbacks.anyError();
      }
    } finally {
      onClose!();
      removeActionInProgress();
    }
  };

  return (
    <ControlVisitModalView
      {...props}
      onClose={handleModalClose}
    />
  );
};
